import { DialogContent, DialogBottomPanel, Button, useInterval, ProgressBar, makeDialogOpener } from "@optimed/react";
import { DialogProps, useDialogSize } from "@optimed/react";
import { asyncTasksService } from "api/asyncTaskService";
import { AsyncTaskInfo, AsyncTaskStatus } from "api/models";
import { useState } from "react";

interface SyncDialogProps extends DialogProps<SyncDialogResult> {
  asyncTask: AsyncTaskInfo;
}

interface SyncDialogResult {}

export function SyncDialog(props: SyncDialogProps) {
  useDialogSize("500px", "400px");
  const { dialog } = props;

  const [taskInfo, setTaskInfo] = useState<AsyncTaskInfo>(props.asyncTask);
  const finalStatuses = [AsyncTaskStatus.Finished, AsyncTaskStatus.Cancelled, AsyncTaskStatus.Faulted];

  useInterval(() => {
    if (finalStatuses.includes(taskInfo.status)) {
      return;
    }
    asyncTasksService.status({ taskId: taskInfo.taskId }).then(setTaskInfo);
  }, 1000);

  const onAccept = () => {
    dialog.close({});
  };

  return (
    <DialogContent header="Synchronizacja danych">
      <div>
        <ProgressBar progress={taskInfo.progress?.percent ?? 0} />
        <div>{taskInfo.progress?.message}</div>
        <div className="text-muted">Status: {AsyncTaskStatus[taskInfo.status!]}</div>
      </div>
      <DialogBottomPanel>
        <Button onClick={onAccept} disabled={!finalStatuses.includes(taskInfo.status)}>
          Zamknij
        </Button>
      </DialogBottomPanel>
    </DialogContent>
  );
}

export const syncDialog = makeDialogOpener(SyncDialog);
